module.exports = __webpack_public_path__ + "img/cancel_icon_1.a17a8729.svg";